import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock } from "lucide-react";
import { PageHead, Wrap } from "@/components/Content";
import { CinematicSection } from "@/components/CinematicSection";
import { Seo, breadcrumbSchema } from "@/components/Seo";
import { ARTICLE_LIST } from "@/data/articles";

export default function Library() {
  return (
    <div className="bg-ink min-h-screen pb-24">
      <Seo
        title="The CardScience Library | Card Care & Grading Prep Guides"
        description="Educational guides on card cleaning, comic preservation and grading preparation — written by the CardScience HQ lab. Honest answers, no hype, no guaranteed grades."
        path="/library"
        jsonLd={breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Library", path: "/library" },
        ])}
      />

      <CinematicSection
        image="https://images.pexels.com/photos/28900010/pexels-photo-28900010.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
        contain={false}
        reverse
        alt="An immersive gallery of completed card and comic work"
        label="The CardScience Library"
        headline="KNOW BEFORE"
        accent="YOU SUBMIT."
        sentence="Straight, lab-tested answers to the questions collectors actually ask — cleaning, preservation, grading prep and safe shipping. No hype, no guaranteed grades."
        primaryTo="/submit"
        primaryLabel="SUBMIT A COLLECTIBLE"
        secondaryTo="/before-after"
        secondaryLabel="View Results"
      />

      <Wrap className="py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {ARTICLE_LIST.map((a) => (
            <Link
              key={a.slug}
              to={a.path}
              data-testid={`library-card-${a.slug}`}
              className="group rounded-2xl border border-[color:var(--line)] glass p-7 transition-colors hover:border-[color:var(--cyan)]"
            >
              <div className="flex items-center gap-3 mb-4">
                <BookOpen size={16} className="text-[color:var(--cyan)]" />
                <span className="eyebrow">{a.category}</span>
              </div>
              <h2 className="h-display text-xl text-chrome leading-tight group-hover:text-white transition-colors">
                {a.title}
              </h2>
              <p className="text-[color:var(--chrome-2)] leading-relaxed mt-3 text-sm">{a.excerpt}</p>
              <div className="flex items-center justify-between mt-5">
                <span className="flex items-center gap-2 text-xs text-[color:var(--chrome-3)]">
                  <Clock size={13} /> {a.readTime}
                </span>
                <span className="flex items-center gap-1.5 text-sm text-[color:var(--cyan)] group-hover:gap-2.5 transition-all">
                  Read <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 mt-14">
          <Link to="/submit" className="btn-holo inline-flex items-center gap-2 rounded-xl px-7 py-4 text-sm">
            SUBMIT A COLLECTIBLE <ArrowRight size={16} />
          </Link>
          <Link to="/before-after" className="btn-ghost inline-flex items-center gap-2 rounded-xl px-7 py-4 text-sm">
            BEFORE &amp; AFTER
          </Link>
        </div>
      </Wrap>
    </div>
  );
}
